// ResetPassword.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { validatePassword } from '../../utils/password-validation';
import api from '../../services/api';
import '../../styles/PasswordRequirementsFormatting.css';
import './ResetPassword.css';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get('email');
    if (emailParam) {
      setEmail(decodeURIComponent(emailParam));
    }
  }, [location]);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    const passwordError = validatePassword(newPassword);
    if (passwordError) {
      setError(passwordError);
      return;
    }
    setIsLoading(true);
    try {
      console.log('Sending reset request with:', { email, resetCode, newPassword });
      const response = await api.post('/api/reset-password', {
        email,
        resetCode,
        newPassword
      });

      if (response?.data?.success) {
        setMessage('Password has been reset successfully.');
        setError('');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setError(response?.data?.error || 'Failed to reset password.');
        setMessage('');
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        setMessage('');
        setError(error.response.data.error);
      } else {
        setError('Something went wrong. Please try again.');
        setMessage('');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="reset-password-container">
      <h2>Reset Password</h2>
      {message && <p className="success-message">{message}</p>}
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleResetPassword} className="reset-password-form">
        <div className="input-group">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="form-input"
          />
        </div>
        <div className="input-group">
          <input
            type="text"
            placeholder="Reset Code"
            value={resetCode}
            onChange={(e) => setResetCode(e.target.value)}
            required
            className="form-input"
          />
        </div>
        <div className="input-group password-group">
          <input
            type={showNewPassword ? 'text' : 'password'}
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="form-input"
          />
          <span
            className="toggle-password"
            onClick={() => setShowNewPassword(!showNewPassword)}
          >
            {showNewPassword ? (
              <i className="fas fa-eye" />
            ) : (
              <i className="fas fa-eye-slash" />
            )}
          </span>
        </div>
        <div className="input-group password-group">
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="form-input"
          />
          <span
            className="toggle-password"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? (
              <i className="fas fa-eye" />
            ) : (
              <i className="fas fa-eye-slash" />
            )}
          </span>
        </div>
        <button type="submit" className="reset-password-button button-loading"  disabled={isLoading}>
            {isLoading ? (
                <div className="spinner"></div>
            ) : (
                'Reset Password'
            )}
        </button>
      </form>
      <div className="password-requirements">
        <p>Password must contain:</p>
        <ul>
          <li>Between 8 and 25 characters</li>
          <li>Uppercase and lowercase letters</li>
          <li>At least one number</li>
        </ul>
      </div>
    </div>
  );
};

export default ResetPassword;